import type { Reservation, SlotBlock } from '@app-types/models/reservation';

export const getSlotClass = (reservation: Reservation | null | undefined, slotBlock: SlotBlock | null | undefined, isOpen: boolean, rearrangeMode: boolean): string => {

  const statusClassMap: Record<string, string> = {
    'pending-for-approval': 'app-pending',
    'confirmed': 'app-confirmed',
    'approval-timeout': '',
    'customer-cancelled': '',
    'business-cancelled': '',
    'no-show': '',
    'completed': 'app-completed',
    'auto-completed': 'app-completed'
  };
  let reservationType = '';
  if (reservation) {
    reservationType = reservation?.createdType === 'self-created' ? 'self-created' : statusClassMap[reservation.status] || reservation.status;
  }

  let slotClass = '';
  switch (true) {
    case !!reservation:
      slotClass = reservationType;
      break;
    case !!slotBlock && !slotBlock.isOpen:
      slotClass = 'blocked';
      break;
    case isOpen:
      slotClass = 'open';
      break;
    default:
      slotClass = 'closed';
  }
  if (rearrangeMode) slotClass += ' rearrange-mode';
  return slotClass;
};
